import { PageId } from '../../../constants';
import { getAllSiteComponents } from '../../editor-sdk-actions';

export abstract class BaseAddPage {
  public constructor(
    protected editorSDK,
    protected appToken,
    protected instance,
  ) {}

  public abstract shouldAddPage();

  public abstract execute();

  protected abstract get widgetId();

  public abstract get widgetName();

  public abstract get stepTranslate();

  protected async addBookingsPage(pageId: PageId) {
    try {
      return await this.editorSDK.document.tpa.add.component(this.appToken, {
        componentType: this.editorSDK.document.tpa.TPAComponentType.Page,
        page: {
          pageId,
          shouldNavigate: false,
        },
      });
    } catch (e) {
      const errorMessage = `${
        e?.message ? e.message : JSON.stringify(e)
      } | addBookingsPage Failed. pageId: ${pageId}`;
      throw new Error(errorMessage);
    }
  }

  protected async getAllSitePages() {
    try {
      return await this.editorSDK.pages.data.getAll();
    } catch (e) {
      const errorMessage = `getAllSitePages Failed - ${
        e?.message ? e.message : JSON.stringify(e)
      }`;
      throw new Error(errorMessage);
    }
  }

  protected async createPageState(pageId: PageId, pageName: string) {
    try {
      const allSitePages = await this.getAllSitePages();
      const pageData = allSitePages.find((page) => page.tpaPageId === pageId);
      if (pageData) {
        await this.editorSDK.document.pages.setState(this.appToken, {
          state: {
            [pageName]: [{ id: pageData.id }],
          },
        });
      }
    } catch (e) {
      const errorMessage = `createPageState Failed - ${
        e?.message ? e.message : JSON.stringify(e)
      }`;
      throw new Error(errorMessage);
    }
  }
}
